import { memo } from 'react'

import * as Styled from './styled'

interface IProps {
  isChecked?: boolean
  onChange: () => void
  className?: string
  isDisabled?: boolean
}

const ToggleSwitcher: React.FC<IProps> = props => {
  const { isChecked = false, onChange, className, isDisabled = false } = props

  return (
    <Styled.ToggleSwitcherWrapper
      className={className}
      role="switch"
      aria-checked={isChecked}
      aria-disabled={isDisabled}
      onClick={onChange}
      $isDisabled={isDisabled}
      $isChecked={isChecked}
    >
      <Styled.ToggleSwitcherCircle $isChecked={isChecked} />
    </Styled.ToggleSwitcherWrapper>
  )
}

export default memo(ToggleSwitcher)
